/**
 * Agent constants for Matrix Studio
 *
 * Centralized constants to avoid magic strings throughout the codebase
 */

export const WORKFLOW_AGENT_NAME = 'Workflow Agent';
export const PLG_ALLOWED_AGENT = 'Agent Builder';
